import React, { useEffect, useState } from "react";
import {
  Row,
  Col,
  CardBody,
  Card,
  Alert,
  Container,
  Input,
  Label,
  Form,
  FormFeedback,
  Button,
  Spinner,
} from "reactstrap";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";
import "react-toastify/dist/ReactToastify.css";

// action
import { recoverPassword, resetPassword } from "../../slices/thunks";

//redux
import { useDispatch } from "react-redux";

import { Link, useLocation } from "react-router-dom";

//import images
import logoLight from "../../assets/images/logo-light.png";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import logoAiCare from "../../assets/images/pn.png";
import logoAiCareEsteso from "../../assets/images/aicare.png";
import loghiNazionali from "../../assets/images/loghi-nazionali.png";

const ResetPassword = (props: any) => {
  const dispatch: any = useDispatch();
  const [loader, setLoader] = useState<boolean>(false);
  const [success, setSuccess] = useState<boolean>(false);
  const [error, setError] = useState<boolean>(false);

  const location = useLocation();
  const [userToken, setUserToken] = useState("");

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Yup.object({
      password: Yup.string().required("Please Enter Your Password"),
      confirm_password: Yup.string()
        .oneOf([Yup.ref("password"), ""])
        .required("Confirm Password is required"),
    }),
    onSubmit: (values) => {
      setLoader(true);
      dispatch(resetPassword({ ...values, userToken }, setSuccess, setError));
      setLoader(false);
    },
  });

  useEffect(() => {
    if (success) {
      setTimeout(() => setSuccess(false), 10000);
    }

    setTimeout(() => {
      setError(false);
    }, 10000);
  }, [success, error]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");
    if (token) {
      setUserToken(token);
    }
  }, [location.search]);

  document.title = "Reset Password | AICare";

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="auth-page-content">
          <div
          className="mb-lg-5"
          style={{ textAlign: "center", backgroundColor: "#fff" }}
        >
          <span className="logo-lg">
            <img
              src={loghiNazionali}
              alt=""
              className="img-fluid"
              style={{ minHeight: 30, maxHeight: 80 }}
            />
          </span>
        </div>
          <Container>
            <Row>
              <Col lg={12}>
                <div className="text-center mt-sm-5 mb-4 text-white-50">
                  <div>
                    <Link to="/" className="d-inline-block auth-logo">
                      <img src={logoAiCare} alt="" height="45" />
                      <img src={logoAiCareEsteso} alt="" height="45" />
                    </Link>
                  </div>
                  <p className="mt-3 fs-15 fw-medium" style={{color: "black"}}>
                    Dashboard AICare
                  </p>
                </div>
              </Col>
            </Row>

            <Row className="justify-content-center">
              <Col md={8} lg={6} xl={5}>
                <Card className="mt-4">
                  <CardBody className="p-4">
                    <div className="text-center mt-2">
                      <h5 className="text-primary">Reset Password</h5>
                      <p className="text-muted">Reset Account Password</p>
                    </div>
                    <div className="p-2 mt-4">
                      {success && success ? (
                        <>
                          <Alert color="success">
                          La password è stata reimpostata con successo! Per favore
                            torna alla pagina di accesso per effettuare il login.
                          </Alert>
                        </>
                      ) : null}

                      {error && error ? (
                        <Alert color="danger">
                          <div>
                            Si è verificato un problema durante il salvataggio della nuova password! Controlla
                            se l'email inserita è corretta.
                          </div>
                        </Alert>
                      ) : null}
                      <Form
                        onSubmit={(e) => {
                          e.preventDefault();
                          validation.handleSubmit();
                          return false;
                        }}
                        className="needs-validation"
                        action="#"
                      >
                        <div className="mb-3">
                          <Label htmlFor="userpassword" className="form-label">
                            Password <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="password"
                            type="password"
                            placeholder="Enter Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.password || ""}
                            invalid={
                              validation.touched.password &&
                              validation.errors.password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.password &&
                          validation.errors.password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.password}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mb-2">
                          <Label
                            htmlFor="confirmPassword"
                            className="form-label"
                          >
                            Conferma Password{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <Input
                            name="confirm_password"
                            type="password"
                            placeholder="Conferma Password"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.confirm_password || ""}
                            invalid={
                              validation.touched.confirm_password &&
                              validation.errors.confirm_password
                                ? true
                                : false
                            }
                          />
                          {validation.touched.confirm_password &&
                          validation.errors.confirm_password ? (
                            <FormFeedback type="invalid">
                              <div>{validation.errors.confirm_password}</div>
                            </FormFeedback>
                          ) : null}
                        </div>

                        <div className="mt-4">
                          <Button
                            color="success"
                            className="w-100"
                            type="submit"
                            disabled={loader}
                          >
                            {loader && (
                              <Spinner size="sm" className="me-2">
                                {" "}
                                Loading...{" "}
                              </Spinner>
                            )}
                            Invia Email
                          </Button>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
                <div className="mt-4 text-center">
                  <p className="mb-0">
                    Possiedi già un account?{" "}
                    <Link
                      to="/login"
                      className="fw-semibold text-primary text-decoration-underline"
                    >
                      {" "}
                      Accedi{" "}
                    </Link>{" "}
                  </p>
                </div>
              </Col>
            </Row>
          </Container>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default ResetPassword;
